import { Injectable } from "@angular/core";
import { UTCDate } from "@ankaadia/ankaadia-shared";
import { reportProgress } from "@ankaadia/ankaadia-shared-frontend";
import { ExcelAddInDto, GetChangeStatisticsDataGQL } from "@ankaadia/graphql";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class ChangeStatisticsService {
  constructor(private readonly getChangeStatistics: GetChangeStatisticsDataGQL) {}

  getChangeStatisticsData(language: string, fromDate: UTCDate, toDate: UTCDate): Observable<ExcelAddInDto> {
    return this.getChangeStatistics
      .subscribe({
        input: {
          language: language,
          fromDate: fromDate,
          toDate: toDate,
        },
      })
      .pipe(
        map((result: any) => result.data.getChangeStatisticsData),
        reportProgress("getChangeStatisticsData", "1", false, { silent: true })
      );
  }
}
